import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export default makeStyles()((theme: Theme) => ({
  buttonMyVault: {
    position: 'relative',
    textTransform: 'none',
    // padding: 0
    // borderStyle: 'solid',
    // borderWidth: 1,
    // borderColor: theme.palette.text.primary,
    marginTop: '0.25rem',
    marginBottom: '0.25rem'
  },
  buttonMyVaultIconDown: {
    fontSize: 24,
    strokeWidth: 0.5,
    color: theme.palette.text.primary
  },
  popover: {
    '& .MuiPaper-root': {
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 8
    },
    width: '100%'
  },
  divider: {
    marginTop: 0,
    marginBottom: 0,
    borderColor: theme.palette.primary.main
  }
}))
